import React, { useContext, useEffect, useState } from 'react'
import { DefectContext } from './SingleDefect'
import { DetailRow } from '../../../../components/Cards/DetailsBox'
import {
  Autocomplete,
  Avatar,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import API from '../../../../services/API'

const AssignedTo = () => {
  const { defect, setDefect, setChangesPresent } = useContext(DefectContext)
  const [staffOptions, setStaffOptions] = useState([])

  useEffect(() => {
    API.post('/users-in-team', {
      team: ['Governance', 'Manager', 'Make Ready', 'Supervisor'],
    }).then((res) => res.status === 200 && setStaffOptions(res.data))
  }, [])

  return (
    <DetailRow label="Assigned To" noBorder>
      <Autocomplete
        value={defect.assignedTo ?? null}
        onChange={(e, value) => {
          setDefect((prev) => ({
            ...prev,
            assignedTo: value,
          }))
          setChangesPresent(true)
        }}
        fullWidth
        isOptionEqualToValue={(opt, value) => opt._id === value._id}
        // renderInput={(params) => <TextField {...params} size="small" />}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <React.Fragment>
                  {defect.assignedTo && (
                    <Avatar
                      src={defect.assignedTo?.photograph}
                      sx={{ width: 18, height: 18, borderRadius: 1 }}
                    />
                  )}
                  {params.InputProps.startAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        options={staffOptions}
        getOptionLabel={(opt) => `${opt.firstName} ${opt.lastName}`}
        renderOption={(props, opt) => (
          <Stack direction="row" gap={1} {...props}>
            <Avatar
              src={opt?.photograph}
              sx={{ width: 18, height: 18, borderRadius: 1 }}
            />
            <Typography>
              {opt?.firstName} {opt?.lastName}
            </Typography>
          </Stack>
        )}
      />
    </DetailRow>
  )
}

export default AssignedTo
